import { useEffect, useState } from 'react';
import WOW from 'wowjs';

import paolamarca from '../../assets/img/equipo/paola-marca.jpg';
import santiagovanegas from '../../assets/img/equipo/santiago-vanegas.jpg';
import paulacordoba from '../../assets/img/equipo/paula-cordoba.jpg';
import angelnavarro from '../../assets/img/equipo/angel-navarro.jpg';
import davidvanegas from '../../assets/img/equipo/david-vanegas.jpg';
import paulaparga from '../../assets/img/equipo/paula-parga.jpg';
import denisse from '../../assets/img/equipo/denisse-sepulveda.jpg';
import nataliavalderrama from '../../assets/img/equipo/natalia-valderrama.jpg';
import danielotalora from '../../assets/img/equipo/daniel-otalora.jpg';

import equipo from '../../assets/img/equipo.jpg'

import './landing.css'
import TestimoniosSlider from './components/TestimoniosSlider';
import Header from './components/Header';
import Footer from './components/Footer';
import { Link } from 'react-router-dom';
import Timeline from './components/TimeLineComo Empezar';

function Landing() {

    const [visible, setVisible] = useState(true);

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    const handleClick = ({
        phone = "16892589039",
        message = "Hola, quiero más información",
    }) => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        // URL de WhatsApp
        const whatsappURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}&app_absent=0`;

        // En iOS Safari, abrir directamente
        if (isIOS) {
            window.location.href = whatsappURL;
        } else {
            window.open(whatsappURL, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <>
            <Header currentSection="home" />
            <header id="home" className="home vh-100 d-flex flex-column justify-content-center align-items-center mt-5">
                <div className='d-flex flex-column justify-content-center align-items-center mt-5 px-5'>
                    <h1 className="title-banner text-center text-secondary wow slideInLeft z-1">Un asesor experto en inmigración revisará <strong className='shadow-md'>tu caso de asilo de forma gratuita.</strong></h1>
                    <h1 className="subtitle-banner  text-center mt-5 mb-2 wow slideInRight z-1">Somos un equipo dedicado a la asesoría y guía estratégica en procesos migratorios, con un historial comprobado de apoyo a miles de latinos en los Estados Unidos.</h1>
                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce z-1 fs-5" style={{ fontSize: 'clamp(1rem, 3vw, 1.2rem)', backgroundColor: '#131f2d' }}>
                        <i className="bi bi-whatsapp"></i> Agenda tu asesoría sin costo
                    </button>
                </div>
            </header>
            <section id="como-empezar" className="como-empezar">
                <div className='row z-1'>
                    <div className='col-12 col-md-6 align-items-center col-centered mb-3'>
                        <div className='p-4 z-1 wow slideInLeft'>
                            <h1 className="fw-bold text-primary fw-bold text-center">¿Cómo empezar?</h1>
                            <h3 className="fw-bold fw-bold text-center mt-5">Te <span className='text-primary'>acompañamos</span> en tu <span className='text-primary'>proceso migratorio</span> de principio a fin.</h3>
                        </div>
                    </div>
                    <div className='col-12 col-md-6'>
                        <Timeline />
                    </div>
                </div>
                <div className='text-center mt-2 mb-5'>
                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce shadow z-1 fs-4" style={{ fontSize: 'clamp(1rem, 3vw, 1.2rem)', backgroundColor: '#131f2d' }}>
                        <i className="bi bi-whatsapp"></i> Habla con un asesor
                    </button>
                </div>
            </section>
            <section id="equipo" className='equipo'>
                <div className='container'>
                    <div className='row z-1'>
                        <div className='col-12 col-md-6 align-items-center col-centered mb-3 order-1 order-md-0'>
                            <div className='d-md-flex justify-content-center align-items-center p-5'>
                                <img className="rounded-4 wow bounceInDown" style={{ width: "100%" }} src={equipo} alt="Equipo asilo a tu alcance" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 align-items-center col-centered order-0 order-md-1 '>
                            <div className='p-4 z-1 wow slideInLeft'>
                                <h3 className="fw-bold fw-bold text-center"><span className='text-primary'>Contigo en cada paso: El camino nunca lo recorrerás en solitario.</span> Te ofrecemos <span className='text-primary'>la guía y el respaldo experto</span> de un equipo sólido comprometido con ayudarte a construir tu futuro.</h3>
                                <div className='d-flex justify-content-center align-items-center mt-5'>
                                    <div className="experience-card">
                                        <h3 className='fw-bold'>+1000 Clientes</h3>
                                        <p>que hoy disfrutan de la tranquilidad gracias a nuestros servicios de asilo.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="quienes-somos" className="quienes-somos">
                <div className='row z-1'>
                    <div className='col-md-6 col-centered mb-3'>
                        <div className='p-4 z-1 wow slideInLeft'>
                            <h1 className="fw-bold text-primary fw-bold">¿Quiénes somos?</h1>
                            <h1 className="parrafo text-secondary mt-4">
                                Somos un equipo dedicado a brindar asesoría migratoria a la comunidad latina en los Estados Unidos.<br /><br />
                                En Asilo A Tu Alcance, te acompañamos paso a paso para que puedas solicitar asilo —afirmativo o defensivo— o iniciar una petición familiar de forma segura, responsable y con toda la información clara desde el inicio.<br /><br />
                                Nuestra prioridad es tu tranquilidad. Sabemos lo difícil que es enfrentarse a procesos migratorios sin apoyo, por eso nos comprometemos contigo desde el primer momento.
                            </h1>
                            <div className='recuadro mt-3'>
                                <span className=''>Valores que nos definen</span>
                            </div>
                            <div className="d-flex mt-4">
                                <div className="footer-icon me-2"></div>
                                <h1 className="parrafo text-secondary">Responsabilidad</h1>
                            </div>
                            <div className="d-flex">
                                <div className="footer-icon me-2"></div>
                                <h1 className="parrafo text-secondary">Honestidad</h1>
                            </div>
                            <div className="d-flex">
                                <div className="footer-icon me-2"></div>
                                <h1 className="parrafo text-secondary">Cumplimineto</h1>
                            </div>

                            <div className='text-center mt-3'>
                                <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce shadow z-1" style={{ fontSize: 'clamp(1rem, 3vw, 1.2rem)', backgroundColor: '#131f2d' }}>
                                    <i className="bi bi-whatsapp"></i> Habla con un asesor
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="d-flex justify-content-center m-5">
                            <div className='quienes-somos-image shadow'></div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="beneficios" className="sectionFive w-100 fs-1 p-5">
                <h1 className="fw-bold text-primary fw-bold text-center">Tu mejor aliado migratorio en Estados Unidos</h1>
                <div className="row mt-5">
                    <div className="col-md-6 d-flex flex-column justify-content-start align-items-center align-items-md-end">
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bi bi-pencil-square"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Transparencia Total</h4>
                                <p>Tendrás claridad absoluta sobre costos, servicios y el estado de tu proceso en cada etapa.</p>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bi bi-person-check"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Acompañamiento Garantizado y Supervisado</h4>
                                <p>Te brindamos un acompañamiento constante en cada etapa de tu proceso, con un enfoque humano basado en la empatía  y el compromiso genuino con tu historia.</p>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i className="bi bi-calendar-range"></i>
                            </div>
                            <div class="feature-content">
                                <h4>10 Años de experiencia</h4>
                                <p>Entendemos lo que está en juego. No improvisamos: tu futuro legal se construye con experiencia real.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 d-flex flex-column justify-content-start align-items-center align-items-md-start">
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i className="bi bi-briefcase"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Estrategia Integral y Opciones Adicionales</h4>
                                <p>Diseñamos una estrategia completa, explorando y potenciando alternativas migratorias.</p>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i className="bi bi-wallet2"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Financiación Flexible y a tu Medida</h4>
                                <p>Hacemos accesible tu proceso con un plan de pagos personalizados.</p>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i className="bi bi-clock-history"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Evaluación Personalizada y Profunda</h4>
                                <p>No eres un número. Analizamos a fondo tu historia, riesgos y las oportunidades reales para tu caso de asilo o petición familiar.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="nuestros-servicios" className="nuestros-servicios">
                <div className="d-flex justify-content-center align-items-center">
                    <div className="card-info wow slideInRight">
                        <div className='row'>
                            <div className='col-md-4 p-0 col-centered'>
                                <div className='card-nuestros-servicios bg-secondary p-4'>
                                    <h3 className='fw-bold text-white text-center' style={{ letterSpacing: "2px" }}>Analizamos tu caso y buscamos el mejor camino para ti</h3>
                                    <h1 className='parrafo text-grey mt-4' style={{ fontSize: "1.2rem" }}>
                                        En Asilo A Tu Alcance revisamos tu situación migratoria con responsabilidad y honestidad. Te explicamos tus opciones y te guiamos paso a paso para que puedas acceder a los beneficios de tener un estatus legal en Estados Unidos.<br /><br />
                                        Nuestro objetivo es ayudarte a vivir con tranquilidad y construir el futuro que mereces.
                                    </h1>
                                </div>
                            </div>
                            <div className='col-md-8 p-5 col-centered'>
                                <div className='services'>
                                    <h5 className='fw-bold text-secondary'>Solicitud de Asilo (Afirmativo o Defensivo)</h5>
                                    <h1 className='parrafo text-black mt-4 mb-4'>
                                        ¿Estás en EE. UU. y temes regresar a tu país por motivos de persecución o violencia?
                                        Te asesoramos para presentar correctamente tu solicitud de asilo, ya sea de manera afirmativa (si no estás en proceso de deportación) o defensiva (si ya tienes un caso abierto).
                                    </h1>
                                    <a className="d-flex fw-bold text-danger" href="/solicitud-asilo">
                                        <p className='me-2'>Conoce más</p>
                                        <i className="bi bi-arrow-right"></i>
                                    </a>
                                </div>
                                <div className='services mt-5'>
                                    <h5 className='fw-bold text-secondary'>Peticiones Familiares</h5>
                                    <h1 className='parrafo text-black mt-4'>
                                        Si eres residente o ciudadano de EE. UU. y deseas traer a un familiar o ayudarle a obtener un estatus legal, te orientamos en todo el proceso de petición familiar.
                                    </h1>
                                    <a className="d-flex fw-bold text-danger" href="/peticiones-familiares">
                                        <p className='me-2'>Conoce más</p>
                                        <i className="bi bi-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="sectionFour w-100 d-flex flex-column justify-content-center align-items-center fs-1 p-5">
                <h1 className="fw-bold text-white" style={{ fontSize: '1.2em' }}>¿Al solicitar asilo ya no me pueden deportar?</h1>
                <h1 className="parrafo text-white mt-5 mb-5">
                    Es un programa internacional de protección que proporciona refugio y seguridad a personas que enfrentan persecución o peligro en sus países de origen. En los Estados Unidos, este recurso de protección está disponible para quienes temen ser perseguidos o sufrir daños debido a su raza, religión, nacionalidad, opiniones políticas o por pertenecer a un grupo social específico en sus países de origen.
                </h1>
            </section> */}
            <section className="lema w-100 d-flex flex-column justify-content-center align-items-center fs-1 p-5">
                <h1 className="fw-bold text-white" style={{ fontSize: '1.2em' }}>Mereces una nueva vida sin miedos</h1>
                <h1 className="parrafo text-white mt-5 mb-5 text-center">
                    <span className='text-primary fw-bold'>Sabemos que el camino hacia el asilo parece abrumador, pero tu tranquilidad en EE. UU. es nuestra prioridad.</span> No tienes que enfrentar este complejo proceso solo. Estamos aquí para <span className='text-primary fw-bold'>simplificar cada paso</span>, brindándote el acompañamiento experto que necesitas para legalizar tu situación y <span className='text-primary fw-bold'>vivir seguro en Estados Unidos.</span>
                </h1>
                <div className='text-center mt-3'>
                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce shadow z-1" style={{ fontSize: 'clamp(1rem, 3vw, 1.2rem)', backgroundColor: '#B1802D' }}>
                        <i className="bi bi-whatsapp"></i> Comienza tu caso hoy
                    </button>
                </div>
            </section>
            <section id="nuestro-equipo" className="nuestro-equipo w-100 d-flex flex-column justify-content-center align-items-center p-5">
                <h1 className="fw-bold text-primary" >Nuestro Equipo</h1>
                <h1 className="parrafo mt-4 mb-3 text-center text-secondary">
                    En Asilo A Tu Alcance trabajamos con un equipo humano y profesional comprometido con cada historia.
                    Aquí no eres un número. Eres una persona con sueños, y nosotros estamos aquí para ayudarte a cumplirlos.
                </h1>
                <div className="row">
                    <div className="col-md-6 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={paulacordoba} alt="Paula Cordoba" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Paula Cordoba</h2>
                                    <p className="text-white">Directora Paralegal</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={paolamarca} alt="Paola Marca" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Paola Marca</h2>
                                    <p className="text-white">Asesora de Migración</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-4 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={santiagovanegas} alt="Santiago Vanegas" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Santiago Vanegas</h2>
                                    <p className="text-white">Agente Comercial</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className="row">
                    <div className="col-md-4 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={angelnavarro} alt="Angel Navarro" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Angel Navarro</h2>
                                    <p className="text-white">Preparador de Entrevista</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={davidvanegas} alt="David Vanegas" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">David Vanegas</h2>
                                    <p className="text-white">Preparador de Declaraciones</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={paulaparga} alt="Paula Parga" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Paula Parga</h2>
                                    <p className="text-white">Preparador de Formas</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={danielotalora} alt="Daniel Otálora" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Daniel Otálora</h2>
                                    <p className="text-white">Preparador de Declaraciones</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={nataliavalderrama} alt="Natalia Valderrama" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Natalia Valderrama</h2>
                                    <p className="text-white">Preparadora de Peticiones Familiares</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-4 p-3 d-flex justify-content-center align-items-center">
                        <div className="profile-card shadow">
                            <div className="image-container">
                                <img src={denisse} alt="Denisse Sepulveda" className="profile-image" />
                            </div>
                            <div className="overlay">
                                <div className="text-container">
                                    <h2 className="text-white">Denisse Sepulveda</h2>
                                    <p className="text-white">Area de revisiones</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
            <section id="testimonios" className="testimonios w-100 mb-4 pt-0 p-5">
                <h1 className="fw-bold text-primary mb-5 text-center" >Testimonios</h1>
                <TestimoniosSlider />
            </section>
            <section id="preguntas-frecuentes" className="preguntas-frecuentes w-100 p-5">
                <h1 className="fw-bold text-white text-center" >Preguntas Frecuentes</h1>
                <h1 className="parrafo mt-2 mb-5 text-center text-white">
                    Estas son algunas de las preguntas mas frecuentes.
                </h1>
                <div className="accordion">
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" style={{ borderRadius: "15px" }}>
                                ¿Puedo solicitar asilo si entré por la frontera sin visa?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Sí, es posible solicitar asilo en EE. UU. aunque hayas ingresado por la frontera sin una visa. La ley de inmigración permite que cualquier persona que se encuentre dentro del país —sin importar su estatus migratorio— solicite protección si teme regresar a su país por motivos como persecución, violencia, amenazas, discriminación grave, entre otros.<br /><br />
                                <strong>Te ayudamos a:</strong> <br /><br />
                                •	Preparar tu declaración personal
                                •	Reunir pruebas de tu situación
                                •	Entender los tipos de asilo (afirmativo o defensivo)
                                •	Presentar tu solicitud dentro del tiempo permitido (generalmente, el primer año después de tu entrada)<br /><br />
                                <strong>Importante:</strong> Cada caso es único. Por eso, analizamos tu historia para determinar si calificas y cómo presentar tu solicitud correctamente.

                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={{ borderRadius: "15px" }}>
                                ¿Qué es el asilo afirmativo y el asilo defensivo? ¿Cuál me corresponde?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <strong>Asilo afirmativo:</strong> Se solicita cuando no estás en proceso de deportación. Es decir, tú mismo decides presentar el caso de forma voluntaria ante USCIS (Servicio de Ciudadanía e Inmigración de EE. UU.).<br /><br />
                                <strong>Asilo defensivo:</strong> Se presenta cuando ya estás en proceso de deportación y necesitas defenderte en una Corte de Inmigración.<br /><br />
                                <strong>¿Cuál te corresponde?</strong>
                                Depende de tu situación actual. Si ingresaste a EE. UU. y no has sido detenido ni citado por un juez, puedes presentar un asilo afirmativo. Si ya estás en proceso ante un juez de inmigración, lo que corresponde es un asilo defensivo.<br /><br />
                                Nosotros te orientamos desde la primera asesoría para que sepas cuál es la vía adecuada.

                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={{ borderRadius: "15px" }}>
                                ¿Qué pasa si ya tengo una orden de deportación?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Tener una orden de deportación no significa que no haya esperanza. Existen alternativas legales, dependiendo de tus circunstancias.<br /><br />
                                <strong>Podemos ayudarte a explorar opciones como:</strong><br /><br />
                                •	Reapertura de tu caso si existen nuevas pruebas o cambios en tu situación<br />
                                •	Solicitud de asilo defensivo si hay riesgo comprobable al regresar a tu país<br />
                                •	Suspensión de la deportación en algunos casos de peligro inminente<br />
                                •	Evaluar si calificas para otras protecciones como la ley NACARA, DACA, TPS, entre otras<br /><br />
                                Es fundamental actuar rápidamente. Revisamos tu expediente y trabajamos contigo para buscar la mejor estrategia legal disponible.

                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingFour">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" style={{ borderRadius: "15px" }}>
                                ¿Qué documentos necesito para solicitar asilo?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Para solicitar asilo necesitas reunir varios documentos que respalden tu historia. Algunos de los más comunes son:<br /><br />
                                •	Pasaporte o documento de identidad de tu país<br />
                                •	Formulario I-589 (Solicitud de Asilo y Suspensión de Remoción)<br />
                                •	Declaración personal escrita (explicando por qué solicitas asilo)<br />
                                •	Pruebas que respalden tu caso (fotos, cartas, denuncias, noticias, certificados médicos, etc.)<br />
                                •	Información de testigos, si los hay<br />
                                •	Registro de tu entrada al país y documentos migratorios<br /><br />
                                <strong>Nuestro equipo te ayuda a organizar cada documento y preparar tu caso de forma clara y sólida.</strong>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingFive">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive" style={{ borderRadius: "15px" }}>
                                ¿Cuánto tiempo tarda una petición familiar?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                El tiempo depende del tipo de relación familiar y del estatus migratorio del peticionario (residente o ciudadano).<br /><br />
                                Aquí algunos ejemplos aproximados:<br /><br />
                                <strong>•	Ciudadano estadounidense → cónyuge o hijos menores:</strong> 12 a 18 meses<br />
                                <strong>•	Residente permanente → cónyuge o hijos menores:</strong> 18 a 36 meses<br />
                                <strong>•	Ciudadano estadounidense → padres:</strong> 12 a 18 meses<br />
                                <strong>•	Ciudadano estadounidense → hermanos:</strong> hasta 10 años o más<br /><br />
                                <strong>También influye:</strong><br /><br />
                                •	El país de origen del beneficiario<br />
                                •	La carga actual del sistema migratorio<br />
                                •	Posibles demoras por errores en los formularios<br /><br />
                                Por eso, te orientamos para que presentes todo de manera correcta desde el inicio y evites retrasos.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingSix">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix" style={{ borderRadius: "15px" }}>
                                ¿La asesoría tiene algún costo?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <strong>Ofrecemos una primera asesoría gratuita</strong>, en la que analizamos tu situación, te explicamos tus opciones legales y resolvemos tus dudas.<br /><br />
                                Después de esta primera cita, te ofrecemos un plan de trabajo claro, con precios justos y sin letras pequeñas.<br /><br />
                                <strong>Nos comprometemos a ser honestos desde el principio.</strong><br /><br />
                                No hacemos promesas falsas, y siempre sabrás exactamente qué estás pagando y qué incluye cada servicio.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item mb-3" style={{ borderRadius: "15px" }}>
                        <h2 className="accordion-header" id="headingSeven">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven" style={{ borderRadius: "15px" }}>
                                ¿Al solicitar asilo ya no me pueden deportar?
                                <span className="ms-auto d-flex align-items-center"></span>
                            </button>
                        </h2>
                        <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Es un programa internacional de protección que proporciona refugio y seguridad a personas que enfrentan persecución o peligro en sus países de origen.<br />
                                En los Estados Unidos, este recurso de protección está disponible para quienes temen ser perseguidos o sufrir daños debido a su raza, religión, nacionalidad, opiniones políticas o por pertenecer a un grupo social específico en sus países de origen.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-contact-banner">
                <div className="contact-banner-container">
                    <h1 className="contact-banner-title fw-bold text-primary">Estamos donde nos necesites</h1>
                    <p className="contact-banner-subtitle">
                        Contamos con la experiencia necesaria para gestionar procesos migratorios en los 50 estados del país, ofreciendo el mismo nivel de compromiso, calidad y acompañamiento estés donde estés.<br /><br />
                        ¡Empieza tu proceso hoy mismo!
                    </p>

                    <div className="contact-banner-buttons">
                        <button onClick={handleClick}
                            className="border-0 btn-primary fs-5"
                        >
                            Agenda tu consulta sin costo <i className="bi bi-arrow-right"></i>
                        </button>
                        <Link to={'/contacto'} className="btn-secondary fs-5">
                            Te llamamos <i className="bi bi-phone"></i>
                        </Link>
                    </div>

                    <p className="contact-banner-note">
                        <i className="bi bi-lock"></i> Manejamos tus datos de forma confidencial
                    </p>
                </div>
            </section>
            <Footer />
            <div className="chat-container">
                {visible && (
                    <div className="chat-popup">
                        <div className="chat-text">
                            <strong>Asilo a tu Alcance</strong><br />
                            ¡Hola! Soy tu asesor de Inmigración. ¿Cómo te puedo ayudar?
                        </div>
                        <span className="close-btn" onClick={() => setVisible(false)}>×</span>
                    </div>
                )}
                <div className="chat-icon">
                    <button onClick={handleClick} className="border-0 btn-wsp d-flex align-items-center justify-content-center" target="_blank">
                        <i className="bi bi-whatsapp icono"></i>
                    </button>
                </div>
            </div>

        </>
    );
}

export default Landing;